import { Rest } from "utilities/rest";
import * as ActionCreator from "utilities/action.creator";
import { $processing, $done } from "services/activity/action";

export const MODULE = "Select";

const API_URL = `${process.env.REACT_APP_SERVICE_SYSTEM_URL}`;

export const $get = ActionCreator.Async(MODULE, "Get", (url, params = {}) => {
  return async (dispatch) => {
    console.log("===========ke get ga ?===================", url)
    dispatch($processing($get.OPERATION));

    return await Rest.GET(`${API_URL}${url}`, params)
      .then((response) => {
        return response;
      })
      .catch((error) => {
        return false;
      })
      .finally(() => {
        dispatch($done($get.OPERATION));
      });
  };
});
